export default ['addFormService', 'activeDraftService', '$timeout',
  function(addFormService, activeDraftService, $timeout) {
    const service = {};
    let frameWin, iframe;

    const handleMessage = resolve => e => {
      if (!/cian\.ru$/.test(e.origin)) return;

      let draft;

      try {
        draft = JSON.parse(e.data) || {};
      } catch (e) {
        return;
      }

      if (!draft.locationChanged) return; // Работем только с помеченным черновиком

      // if (draft.geo) delete draft.geo;

      delete draft.locationChanged;
      delete draft.userId;

      frameWin.postMessage(JSON.stringify({key: 'savedDraft', method: "remove"}), "*");

      resolve(draft);
    };

    service.fetchSubdomainDraft = () => {
      iframe = document.getElementById('subdomain-draft');

      if (!iframe) return Promise.resolve();

      // some browser throw exception when you try to access
      // contentWindow for the first time, it work when you do that second time
      try {
        frameWin = iframe.contentWindow;
      } catch(e) {
        frameWin = iframe.contentWindow;
      }

      if (!frameWin) return Promise.resolve();

      frameWin.postMessage(JSON.stringify({key: 'savedDraft', method: "get"}), "*");

      return new Promise((resolve) => {
        window.addEventListener('message', handleMessage(resolve));

        // Если в течении 2 секунд не пришел ответ, резолвим промис
        $timeout(() => {
          window.removeEventListener('message', handleMessage(resolve));

          resolve();
        }, 2000);
      });
    };

    service.saveDraft = () => {
      const { ad, form } = addFormService;

      // сохраняем локально состояние ФП
      activeDraftService.setDraftMode(activeDraftService.modeEnums.LOCAL);
      activeDraftService.saveDraft(ad, form, true);
      activeDraftService.setDraftMode('auto');

      const savedDraft = JSON.parse(localStorage.getItem('savedDraft'));

      if (savedDraft) {
        // Добавим свойство locationChanged, чтобы отличать от обычных локальных черновиков
        localStorage.setItem('savedDraft', JSON.stringify({...savedDraft, locationChanged: true}));
      }
    };

    // Для вызова в хэдере при смене региона
    window.saveDraftLocal = service.saveDraft;

    return service;
  },
];
